import React, { useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import type { OperationsMenuForLanding$key } from './__generated__/OperationsMenuForLanding.graphql';
import { AlertsMenuItemContent } from './alerts-content/alerts-menu-item/AlertsMenuItemContent.tsx';
import { OperationsExpandableMenuItem } from './operations-expandable-menu-item/index.tsx';
import { AlertsMenuItemContentNew } from './alerts-content/alerts-menu-item/AlertsMenuItemContentNew.tsx';
import { useAlertsPopoutStore } from './operations-expandable-menu-item/action-buttons/useAlertsPopoutStore.tsx';

type OperationsMenuForLandingProps = Nav4DragAndDropMenuItemProps & {
	isExpanded: boolean;
	queryRef: OperationsMenuForLanding$key;
};

export const OperationsMenuForLanding = (
	props: OperationsMenuForLandingProps,
): React.JSX.Element => {
	const { isExpanded, queryRef, ...dndProps } = props;
	const data = useFragment<OperationsMenuForLanding$key>(
		graphql`
			fragment OperationsMenuForLanding on Query {
				...AlertsMenuItemContentNew
				...AlertsMenuItemContent
			}
		`,
		queryRef,
	);

	const {
		state: { lastVisitedSearch },
		setContent,
	} = useAlertsPopoutStore();

	useEffect(() => {
		if (fg('operations_nav4_remaining_items') ? lastVisitedSearch : false) {
			setContent(<AlertsMenuItemContent queryRef={data} />);
		}

		if (!fg('operations_nav4_remaining_items')) {
			return () => {
				setContent(null);
			};
		}
	}, [data, lastVisitedSearch, setContent]);

	return (
		<UFOSegment name="nav4-sidebar-operations-trigger-button">
			<OperationsExpandableMenuItem
				AlertsMenuItemContent={
					fg('operations_nav4_remaining_items') ? (
						<UFOSegment name="nav4-sidebar-operations-expanded-items">
							<AlertsMenuItemContentNew queryRef={data} />
						</UFOSegment>
					) : (
						<AlertsMenuItemContent queryRef={data} />
					)
				}
				isExpanded={isExpanded}
				{...dndProps}
			/>
		</UFOSegment>
	);
};
